/** @format */

import FilterOptionInput from './filter_option_input';
import {ConditionalButton, IfElse} from 'frontier-utilities';
import FilterOption from './filter_option_list';
import {Button} from '@/components/ui/button';
import {X, Filter} from 'lucide-react';
import {If} from 'frontier-utilities';
import React from 'react';

export default function SearchFilter(props) {
    const {className = '', label, activeLabel} = props;

    const [adding, setAdding] = React.useState(false);
    const [show_option_list, setShowOptionList] = React.useState(false);
    const [current_filter, setCurrentFilter] = React.useState({});

    const showFilterList = () => {
        setShowOptionList(true);
        setCurrentFilter({});
    };

    const handleSelect = e => {
        const current_filter = JSON.parse(e.currentTarget.dataset.value);
        setAdding(true);
        setShowOptionList(false);
        setCurrentFilter(current_filter);
    };

    const handleCancel = () => {
        setAdding(false);
        setShowOptionList(false);
        setCurrentFilter({});
    };

    return (
        <>
            <div className="tw-relative">
                <div className={className}>
                    <If condition={show_option_list || adding}>
                        <Button
                            onClick={handleCancel}
                            variant="primary"
                            className="tw-rounded-tr-full tw-rounded-br-full tw-rounded-tl-none tw-rounded-bl-none tw-py-2.5">
                            <X size="18" />
                            <If condition={label}>
                                <span className="tw-text-xs">{activeLabel}</span>
                            </If>
                        </Button>
                    </If>
                    <If condition={!show_option_list && !adding}>
                        <Button
                            onClick={showFilterList}
                            variant="primary"
                            className="tw-rounded-tr-full tw-rounded-br-full tw-rounded-tl-none tw-rounded-bl-none tw-py-2.5">
                            <Filter size="18" />
                            <If condition={activeLabel}>
                                <span className="tw-text-xs">{label}</span>
                            </If>
                        </Button>
                    </If>
                </div>

                <If condition={show_option_list || adding}>
                    <div
                        style={{
                            zIndex: 4000,
                            position: 'absolute',
                            top: '0',
                            transform: 'translateX(-100%)',
                            left: 0
                        }}>
                        <IfElse condition={show_option_list}>
                            <FilterOption
                                list={props.filter_option_list}
                                onSelect={handleSelect}
                                onCancel={handleCancel}
                            />
                            <FilterOptionInput
                                filter={current_filter}
                                onSave={props.onAdd}
                                onCancel={handleCancel}
                            />
                        </IfElse>
                    </div>
                </If>
            </div>
        </>
    );
}
